import { Auth } from 'aws-amplify';

import { setLoading, setCurrentQuote } from './driversSlice';
import quoteApi from '../../../../utils/quoteAPi';

export const generateDriverData = async (dispatch, formData) => {
  dispatch(setLoading(true));
  const body = {
    request: 'GenerateDriverQuote',
    custId: 'UPS',
    quoteUserId: (await Auth.currentSession()).getIdToken().payload.email,
    ...formData,
  };
  await quoteApi
    .post('', body, {
      headers: {
        Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
      },
    })
    .then(resp => {
      dispatch(setCurrentQuote(resp?.data?.body));
      dispatch(setLoading(false));
    });
};
